const subscriptions = []

const callActionListeners = action => {
	subscriptions
		.filter(({ type }) => typeof action === 'object' && type === action.type)
		.forEach(({ listener }) => listener(action))
}

export const subscribeAction = (action, listener) => {
	if (typeof action !== 'string') {
		throw new Error('Expected the action to be a string.')
	}
	if (typeof listener !== 'function') {
		throw new Error('Expected the listener to be a function.')
	}
	const subscription = { type: action, listener }
	subscriptions.push(subscription)
	return () => {
		const index = subscriptions.indexOf(subscription)
		if (index !== -1) {
			subscriptions.splice(index, 1)
		}
	}
}

export const subscribeActionMiddleware = () => next => action => {
	const result = next(action)
	callActionListeners(action)
	return result
}
